export default __webpack_public_path__ + "static/26381-1a3c6defc1cc15271e97fcc474d66c88.jpg";